import React, { useCallback, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import McpStatusCard from "@/components/mongo/McpStatusCard";
import FieldMapTable from "@/components/mongo/FieldMapTable";
import McpAlertsPanel from "@/components/mongo/McpAlertsPanel";
import McpAuditPanel from "@/components/mongo/McpAuditPanel";

export default function MongoMcpSettingsPage() {
    const { user } = useAuth();
    const isSuper = user?.role === "super_admin";
    const [status, setStatus] = useState(null);
    const load = useCallback(async (fresh = false) => {
        try { setStatus((await api.get(`/admin/mongo-mcp/status${fresh ? "?fresh=true" : ""}`)).data); }
        catch (e) { toast.error(formatApiErrorDetail(e)); }
    }, []);
    useEffect(() => { load(); }, [load]);
    return (
        <div className="px-8 py-8 space-y-5" data-testid="mongo-mcp-settings-page">
            <div className="mb-3">
                <div className="label-xs text-[#7C3AED]">Settings</div>
                <h1 className="font-display text-4xl tracking-tight mt-2">MongoDB MCP</h1>
                <p className="text-sm text-white/50 mt-2 max-w-3xl">
                    Read-only access for AI agents to SiteCentric's aiservice, eSource and regez data through this environment's MongoDB MCP server
                    (assigned on the Radar hub's Connections page). Tenant callers are locked to their own company; only super admins read across companies.
                </p>
            </div>
            {status === null ? <div className="text-xs text-white/40 font-mono" data-testid="mcp-status-loading">Checking the connection…</div> :
                <McpStatusCard status={status} onRefresh={() => load(true)} isSuper={isSuper} />}
            {isSuper ? (
                <>
                    <FieldMapTable onChanged={load} />
                    <McpAlertsPanel onChanged={load} />
                    <McpAuditPanel />
                </>
            ) : (
                <div className="text-xs text-white/45 border border-white/10 rounded-md px-5 py-4" data-testid="mcp-super-only-note">
                    Only super admins can edit the company field map, switch agents' MongoDB tools on and review the audit.
                </div>
            )}
        </div>
    );
}
